export const HEADER_HEIGHT = 62;
export const ROW_HEIGHT = 62;

/**
 * number of rows to be rendered outside the wrapper to decrease flicker and flashes
 **/
export const ROW_OVERSCAN_COUNT = 8;
